import { DataAnalyticsTaggingEvents, DataAnalyticsTaggingEventType } from '@tdwb/core';

const editSections: Array<string> = [ 'email', 'phone', 'address', 'employment' ];
// '' is for edit whose name does not appear on its state name
const editSteps: Array<string> = [ '', 'confirmation', 'success' ];

export class UserProfileAnalytics {
  static messagesTaggingEvents: DataAnalyticsTaggingEvents = {
    pageSecure_MessagesOverviewList: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'list',
        subSection1: 'overview',
        subSection2: 'list',
        customPageName: 'wb_message-overview-list'
      }
    },
    pageSecure_MessagesOverviewGeneral: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'general',
        subSection1: 'overview',
        subSection2: 'general',
        customPageName: 'wb_message-overview-general'
      }
    },
    pageSecure_MessagesCreate_Secure_Message: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'create-secure-message',
        subSection1: 'secure-message',
        subSection2: 'create-secure-message',
        customPageName: 'wb_message-create-secure-message'
      }
    }
  };

  static profileTaggingEvents: DataAnalyticsTaggingEvents = this.addProfileEvents();

  static taggingEvents: DataAnalyticsTaggingEvents = {
    pageProfileOverview: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'overview',
        subSection1: 'profile',
        subSection2: 'overview',
        customPageName: 'wb_profile-overview'
      }
    },
    ...this.profileTaggingEvents,
    ...this.messagesTaggingEvents
  }

  private static addProfileEvents(): DataAnalyticsTaggingEvents{
    const profileEvents: DataAnalyticsTaggingEvents = {};
    editSections.forEach((editSection: string): void=> {
      editSteps.forEach((editStep: string): void=> {
        let stateKey = `pageProfile${editSection.charAt(0).toUpperCase()}${editSection.substring(1)}`;
        if (editStep.length !== 0){
          editStep = `_${editStep.charAt(0).toUpperCase()}${editStep.substring(1)}`;
        }
        stateKey = stateKey.concat(editStep);
        editStep = editStep.toLowerCase().replace('_', '-');
        profileEvents[stateKey] = {
          event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
          page: {
            name: `${editSection}${editStep}`,
            subSection1: 'profile',
            subSection2: `${editSection}${editStep}`,
            customPageName: `wb_profile-${editSection}${editStep}`
          },
          process: {
            processName: `tdw:wbt:profile:edit-${editSection}`
          }
        };
        if (editStep === '' || editStep.includes('success')){
          const processType = editStep === '' ? 'start' : 'complete';
          profileEvents[stateKey].process.processType = `tdw:wbt:profile:edit:${processType}`;
        }
      });
    });
    return profileEvents;
  }
}
